var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginEsp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 116.811,
    height: 77.136,
    viewBox: "0 0 116.811 77.136",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_42751",
    "data-name": "Grupo 42751",
    transform: "translate(-167.48 -807)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20912",
    "data-name": "Trazado 20912",
    d: "M302.367,750.6c0,29.242-20.706,23.125-49.947,23.125s-65.071,8.472-65.071-20.77,29.275-54.4,58.517-54.4,56.5,22.806,56.5,52.048",
    transform: "translate(-19.867 108.448)",
    fill: "#ed92c8",
    opacity: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32318",
    "data-name": "Rect\\xE1ngulo 32318",
    width: 30.892,
    height: 17.934,
    transform: "translate(176.591 846.506)",
    fill: "#ca0875"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32319",
    "data-name": "Rect\\xE1ngulo 32319",
    width: 28.32,
    height: 15.799,
    transform: "translate(177.914 847.574)",
    fill: "#dc7db0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32320",
    "data-name": "Rect\\xE1ngulo 32320",
    width: 3.463,
    height: 18.8,
    transform: "translate(190.663 864.316)",
    fill: "#ca0875"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32321",
    "data-name": "Rect\\xE1ngulo 32321",
    width: 14.412,
    height: 28.69,
    transform: "translate(202.166 854.426)",
    fill: "#dadadb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32322",
    "data-name": "Rect\\xE1ngulo 32322",
    width: 14.412,
    height: 4.819,
    transform: "translate(202.166 863.804)",
    fill: "#6f6e6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_21045",
    "data-name": "Trazado 21045",
    d: "M256.23,779.391v-2.648a.294.294,0,1,0-.588,0v2.648Z",
    transform: "translate(-50.535 75.039)",
    fill: "#8e9090"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32324",
    "data-name": "Rect\\xE1ngulo 32324",
    width: 4.118,
    height: 8.529,
    transform: "translate(205.255 874.587)",
    fill: "#8e9090"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32325",
    "data-name": "Rect\\xE1ngulo 32325",
    width: 4.118,
    height: 8.529,
    transform: "translate(209.372 874.587)",
    fill: "#8e9090"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32326",
    "data-name": "Rect\\xE1ngulo 32326",
    width: 1.443,
    height: 8.529,
    transform: "translate(253.65 874.587)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32327",
    "data-name": "Rect\\xE1ngulo 32327",
    width: 41.177,
    height: 43.397,
    transform: "translate(216.578 839.719)",
    fill: "#f0f1f1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32328",
    "data-name": "Rect\\xE1ngulo 32328",
    width: 12.354,
    height: 43.397,
    transform: "translate(245.401 839.719)",
    fill: "#b6b5b5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32329",
    "data-name": "Rect\\xE1ngulo 32329",
    width: 12.354,
    height: 4.819,
    transform: "translate(245.401 845.488)",
    fill: "#6f6e6e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32330",
    "data-name": "Rect\\xE1ngulo 32330",
    width: 28.825,
    height: 4.819,
    transform: "translate(216.578 845.488)",
    fill: "#b6b5b5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32331",
    "data-name": "Rect\\xE1ngulo 32331",
    width: 12.354,
    height: 4.819,
    transform: "translate(245.401 860.422)",
    fill: "#6f6e6e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32332",
    "data-name": "Rect\\xE1ngulo 32332",
    width: 28.825,
    height: 4.819,
    transform: "translate(216.578 860.422)",
    fill: "#b6b5b5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32333",
    "data-name": "Rect\\xE1ngulo 32333",
    width: 21.653,
    height: 8.529,
    transform: "translate(220.446 874.587)",
    fill: "#b6b5b5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32334",
    "data-name": "Rect\\xE1ngulo 32334",
    width: 1.443,
    height: 8.529,
    transform: "translate(220.446 874.587)",
    fill: "#8e9090"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32335",
    "data-name": "Rect\\xE1ngulo 32335",
    width: 1.443,
    height: 8.529,
    transform: "translate(230.552 874.587)",
    fill: "#8e9090"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32336",
    "data-name": "Rect\\xE1ngulo 32336",
    width: 1.443,
    height: 8.529,
    transform: "translate(240.657 874.587)",
    fill: "#8e9090"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32337",
    "data-name": "Rect\\xE1ngulo 32337",
    width: 23.236,
    height: 28.69,
    transform: "translate(251.284 854.426)",
    fill: "#f0f1f1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32338",
    "data-name": "Rect\\xE1ngulo 32338",
    width: 8.823,
    height: 28.69,
    transform: "translate(265.696 854.426)",
    fill: "#b6b5b5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32339",
    "data-name": "Rect\\xE1ngulo 32339",
    width: 14.412,
    height: 4.819,
    transform: "translate(251.284 863.803)",
    fill: "#b6b5b5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32340",
    "data-name": "Rect\\xE1ngulo 32340",
    width: 8.823,
    height: 4.819,
    transform: "translate(265.696 863.803)",
    fill: "#6f6e6e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32341",
    "data-name": "Rect\\xE1ngulo 32341",
    width: 4.118,
    height: 8.529,
    transform: "translate(254.373 874.587)",
    fill: "#b6b5b5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32342",
    "data-name": "Rect\\xE1ngulo 32342",
    width: 4.118,
    height: 8.529,
    transform: "translate(258.49 874.587)",
    fill: "#b6b5b5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32343",
    "data-name": "Rect\\xE1ngulo 32343",
    width: 1.443,
    height: 8.529,
    transform: "translate(253.65 874.587)",
    fill: "#8e9090"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32344",
    "data-name": "Rect\\xE1ngulo 32344",
    width: 1.443,
    height: 8.529,
    transform: "translate(212.768 874.587)",
    fill: "#6f6e6e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32345",
    "data-name": "Rect\\xE1ngulo 32345",
    width: 1.443,
    height: 8.529,
    transform: "translate(204.386 874.587)",
    fill: "#6f6e6e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32346",
    "data-name": "Rect\\xE1ngulo 32346",
    width: 1.443,
    height: 8.529,
    transform: "translate(261.887 874.587)",
    fill: "#8e9090"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32347",
    "data-name": "Rect\\xE1ngulo 32347",
    width: 4.943,
    height: 8.529,
    transform: "translate(267.754 874.587)",
    fill: "#6f6e6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_21046",
    "data-name": "Trazado 21046",
    d: "M269.983,763.439v-2.647a.294.294,0,1,0-.588,0v2.647Z",
    transform: "translate(-51.605 76.28)",
    fill: "#8e9090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_21047",
    "data-name": "Trazado 21047",
    d: "M298.135,763.439v-2.647a.294.294,0,1,0-.588,0v2.647Z",
    transform: "translate(-53.796 76.28)",
    fill: "#8e9090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_21048",
    "data-name": "Trazado 21048",
    d: "M307.893,779.391v-2.648a.294.294,0,1,0-.588,0v2.648Z",
    transform: "translate(-54.555 75.039)",
    fill: "#8e9090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_21049",
    "data-name": "Trazado 21049",
    d: "M319.815,779.391v-2.648a.294.294,0,1,0-.588,0v2.648Z",
    transform: "translate(-55.483 75.039)",
    fill: "#8e9090"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32348",
    "data-name": "Rect\\xE1ngulo 32348",
    width: 72.354,
    height: 46.338,
    transform: "translate(202.166 836.778)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_21050",
    "data-name": "Trazado 21050",
    d: "M318.676,797.462a2.058,2.058,0,0,1-2.052,2.053H306.065a2.058,2.058,0,0,1-2.052-2.053v-.86a2.058,2.058,0,0,1,2.052-2.049h10.559a2.058,2.058,0,0,1,2.052,2.053Z",
    transform: "translate(-54.3 73.63)",
    fill: "#5ea8ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_21051",
    "data-name": "Trazado 21051",
    d: "M340.271,797.462a2.058,2.058,0,0,1-2.052,2.053H327.66a2.058,2.058,0,0,1-2.052-2.053v-.86a2.058,2.058,0,0,1,2.052-2.053h10.559a2.058,2.058,0,0,1,2.052,2.053Z",
    transform: "translate(-55.979 73.63)",
    fill: "#5ea8ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_21052",
    "data-name": "Trazado 21052",
    d: "M332.042,782.184a2.058,2.058,0,0,1,2.052,2.053v5.607a2.058,2.058,0,0,1-2.052,2.053H311.819a2.058,2.058,0,0,1-2.053-2.053v-1.233a2.058,2.058,0,0,1,2.053-2.053h6.705a2.059,2.059,0,0,0,2.053-2.053v-.268a2.058,2.058,0,0,1,2.052-2.053Z",
    transform: "translate(-54.748 74.593)",
    fill: "#5ea8ac"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32349",
    "data-name": "Rect\\xE1ngulo 32349",
    width: 1.086,
    height: 20.331,
    transform: "translate(266.639 863.804)",
    fill: "#27595e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_21053",
    "data-name": "Trazado 21053",
    d: "M322.246,806.671h-5.823a2.6,2.6,0,0,1-2.6-2.6v-4.6h1.086v4.6a1.512,1.512,0,0,0,1.509,1.51h5.823Z",
    transform: "translate(-55.063 73.248)",
    fill: "#27595e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_21054",
    "data-name": "Trazado 21054",
    d: "M328.878,803.527h-5.823v-1.086h5.823a1.512,1.512,0,0,0,1.509-1.51v-4.6h1.086v4.6a2.6,2.6,0,0,1-2.6,2.6",
    transform: "translate(-55.781 73.492)",
    fill: "#27595e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32350",
    "data-name": "Rect\\xE1ngulo 32350",
    width: 34.577,
    height: 27.359,
    transform: "translate(249.714 856.776)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginEsp);
export default __webpack_public_path__ + "static/media/Login_Esp.e456d76c240ac4805844a71c8c422dc2.svg";
export { ForwardRef as ReactComponent };